/*eslint-disable*/
import React, { useState } from 'react'
import { GoPlus } from 'react-icons/go'
//import Drawer from 'react-modern-drawer'
//import AddBasketDrawerStageTwo from './drawers/AddBasketDrawerStageTwo'
//import AddBasketDrawerStageOne from './drawers/AddBasketDrawerStageOne'
import images from 'assets/images/images'
import { useNavigate } from 'react-router-dom'
import auth from 'utils/Auth'
import { useDispatch, useSelector } from 'react-redux'
import { authModalOpen } from 'redux/features/general/generalSlice'
import useTranslate from 'hooks/useTranslate'
// import images from 'assets/images/images'
import { FormattedNumber, IntlProvider } from 'react-intl'
import { dataLayerPush } from 'utils/Datalayer'

const Product = ({ product, isOpenDrawer, setIsOpenDrawer, setSingleDrawerProduct }) => {
	//const [productStage, setProductStage] = useState(1)
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const [authModal, setAuthModal] = useState(!auth.isHaveToken())
	const { t } = useTranslate()
	const { siteSettings } = useSelector((state) => state.general)
	const addBasketDrawer = () => {
		
		if (authModal) {
			return dispatch(authModalOpen({open:true,returnUrl:`/urun/${product?.url}`}))
		}
		
		setSingleDrawerProduct({ id: product?.id, item: null, productCountStatic: true }) //productCountStatic degerine dikkat et...
		setIsOpenDrawer(!isOpenDrawer)
	}

	const dataLayerClick = () => {
		if(product){
			let layerGetItem = product 
			dataLayerPush({ ecommerce: null });
			dataLayerPush({
				event:"select_item",
				item_list_name: "Listeleme Sayfası",
				ecommerce: {
					item_list_name: "Listeleme Sayfası",
					currency: "TRY",
					items: [layerGetItem]?.map((prev, i) => ({
						item_id: prev.id,
						item_name: prev.name,
						affilication: "Tavuk Dünyası",
						discount: prev.discountAmount,
						index: i,
						item_brand: "Tavuk Dünyası",
						item_category: prev.categories?.[0]?.value,
						item_category2: prev.categories?.[1]?.value ? prev.categories?.[1]?.value : "",
						item_category3: prev.categories?.[2]?.value ? prev.categories?.[2]?.value: "",
						item_list_name: "Listeleme Sayfası",
						price: prev.price,
					}))
				}
			})
		}
	}

	return (
		<div className='product'>
			<div className='product-badges'>
				{product?.isFeaturedProduct && (
					<div className='orangeBadge'>
						<img src={images.orangeBadge} alt='' /> <div className='orangeBadge-text'>{t('popular')}</div>
					</div>
				)}
				{product?.isNewProduct && (
					<div className='orangeBadge'>
						<img src={images.orangeBadge} alt='' /> <div className='orangeBadge-text'>{t('new')}</div>
					</div>
				)}
				{product?.isProductAward && (
					<div className='orangeBadge'>
						<img src={images.orangeBadge} alt='' /> <div className='orangeBadge-text'>{t('award')}</div>
					</div>
				)}
				{product?.spicinessLevel && product?.spicinessLevel > 0 && (
					<div className='orangeBadge'>
						<img src={images.badgeYellowBg} alt='' /> <div className="orangeBadge-images">
							{
								[...Array(4)].map((v,i) => <img key={v} src={ i+ 1 <=  product?.spicinessLevel ?  images.badgeHot : images.badgeHotEmpty } />)
							}
						</div>
					</div>
				)}
				{product?.isVegetarian && (
					<div className='orangeBadge'>
						<img src={images.badgeYellowBg} alt='' />
						<div className="orangeBadge-images">
							<img src={ siteSettings?.common?.vegetarianIconPath} />
						</div>
					</div>
				)}
			</div>
			<a onClick={dataLayerClick} href={`/urun/${product?.url}`} className='product-top'>
				<img src={product?.productImages?.[0]} alt={product?.name} />
				<div className='product-name'>{product?.name}</div>
				<div className='product-description'>{product?.shortDescription}</div>
			</a>
			<div className='product-footer'>
				<div className='d-flex flex-column gap-2'>
					{product?.discountedPrice != product?.price && (
						<div className='additionalProduct-text-oldprice d-flex align-items-start'>
							{
								<IntlProvider locale={'tr'} defaultLocale='en'>
									<FormattedNumber maximumFractionDigits={0} minimumFractionDigits={0} value={product?.price} style={'decimal'} />
								</IntlProvider>
							}{' '}
							TL
						</div>
					)}
					{product?.price && (
						<div className='d-flex align-items-start'>
							{/* <div className='product-footer-price'>{product?.discountedPrice}</div>
            <span className='body-s' style={{ lineHeight: 1 }}>₺</span> */}
							<div className='product-footer-price'>
								{
									<IntlProvider locale={'tr'} defaultLocale='en'>
										<FormattedNumber maximumFractionDigits={0} minimumFractionDigits={0} value={product?.discountedPrice} style={'decimal'} />
									</IntlProvider>
								}{' '}
								TL
							</div>
						</div>
					)}
					{/* <div className='product-footer-price'>{product.discountedPrice}</div> */}
				</div>
				<button onClick={addBasketDrawer}>
					{t('addToCard')} <GoPlus size={28} />
				</button>
			</div>

			{/* <Drawer
        open={isOpenDrawer}
        onClose={() => setIsOpenDrawer(!isOpenDrawer)}
        direction='right'
        className='homeAddBasketDrawer'
      >
        {productStage == 1 && <AddBasketDrawerStageOne product={product} setIsOpenDrawer={setIsOpenDrawer} setProductStage={setProductStage} />}
        {productStage == 2 && <AddBasketDrawerStageTwo setIsOpenDrawer={setIsOpenDrawer} />}
      </Drawer> */}
		</div>
	)
}

export default Product
